(function() {
    'use strict';

    angular.module('process.constants', [])
        .constant('productionCubeStatusConst', {
            started: 'started',
            finished: 'finished',
        })
        .constant('processStageConjunctionsConst', [{
            title: 'i',
            value: 'and'
        }, {
            title: 'lub',
            value: 'or'
        }])
        .constant('processMessagesConst', {
            add: 'Dodano nowy proces!',
            update: 'Dane procesu zostały zaktualizowane!',
            delete: 'Proces został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('processPermissionsConst', {
            view: {
                value: 'view_process',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu procesów!'
            },
            add: {
                value: 'add_process',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania procesów!'
            },
            update: {
                value: 'change_process',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji procesów!'
            },
            delete: {
                value: 'delete_process',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania procesów!'
            }
        })
        .constant('processStageMessagesConst', {
            add: 'Dodano nowy etap procesu!',
            update: 'Dane etapu procesu zaktualizowane!',
            delete: 'Etap procesu został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('processstagePermissionsConst', {
            view: {
                value: 'view_processstage',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu etapów procesu!'
            },
            add: {
                value: 'add_processstage',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania etapów procesu!'
            },
            update: {
                value: 'change_processstage',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji etapów procesu!'
            },
            delete: {
                value: 'delete_processstage',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania etapów procesu!'
            }
        })
        .constant('orderProductProcessStageStatusMessagesConst', {
            addStart: 'Etap procesu został pomyślnie rozpoczęty!',
            addFinish: 'Etap procesu został pomyślnie zakończony!',
            error: 'Wystąpił bład!'
        })
        .constant('orderProductProcessStageStatusPermissionsConst', {
            view: {
                value: 'view_orderproductprocessstagestatus',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu statusów!'
            },
            add: {
                value: 'add_orderproductprocessstagestatus',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania statusów!'
            }
        });
})();
